export class Settings {
  public static VERSION = '1.0.0';
  public static TERM_URL = 'https://duka.digital';

  constructor() {
  }
}
